import React from 'react'
import { EmptyContainer, Container } from './styles'
import { TimelineRadiology } from '../timeline'
import { Loader, NotFound } from '~/components/shared/medicalViews'

interface IProps {
  isLoading: boolean
  hasData: boolean
}

export const RadiologyMainPanel = ({ isLoading, hasData }: IProps): JSX.Element => {
  if (isLoading) {
    return (
      <EmptyContainer>
        <Loader />
      </EmptyContainer>
    )
  }

  if (hasData) {
    return (
      <Container>
        <TimelineRadiology />
      </Container>
    )
  }

  return (
    <EmptyContainer>
      <NotFound />
    </EmptyContainer>
  )
}
